module.exports = __webpack_public_path__ + "static/media/icon_photo.f06533f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/icon_photo.png
// module id = 444
// module chunks = 0